import moment from 'moment';
import Alerts from 'lib/alerts';
import modal from 'helpers/modal.js';
import loader from 'helpers/loader.js';
import {consts as EmployeeConsts} from 'newModels/employee.js';

import FormView from 'commons/views/Form.js';
import template from '../../templates/employee/StatutoryRequirements.ejs';

module.exports = FormView.extend({
    events: function() {
        return Object.assign({}, FormView.prototype.events(), {
            'click .js-is-epf-dropdown-menu a': 'updateIsEpf',
            'change .js-socso-category': 'updateSsfwNumber',
            'ifToggled [name="isEpfMemberBefore1998"]': 'toggleIsEpfMemberBefore1998'
        });
    },

    initialize: function(options) {
        this.options = Object.assign({
            isNew: false,
            unsubmittedPayroll: null,
            template: template
        }, options || {});

        this.options.templateExtra = {
            isNew: this.options.isNew,
            baseRates: this.model.getApplicableEpfRates(),
            employerBaseRate: this.model.getEmployerEpfRate(),
            consts: EmployeeConsts
        };

        this.constraints = {
            mtdBorneByEmployer: {presence: true},
            isEis: {presence: true},
            isEpf: function(value, attrs) {
                const age = moment().diff(attrs.dob || new Date(), 'years');

                if (age < 75) {
                    return null;
                }

                return {inclusion: {
                    within: [false],
                    message: '^This employee is too old to contribute to EPF'
                }};
            },
            isEpfMemberBefore1998: {presence: true},
            epfNumber: function(value, attrs) {
                const age = moment().diff(attrs.dob || new Date(), 'years');
                if (!attrs.isEpf || age > 75) {
                    return null;
                }
                return {
                    format: {
                        pattern: /^\d{1,8}$/,
                        message: '^Invalid EPF Number format (Example: ' +
                            '00000000)'
                    },
                    length: {
                        is: 8,
                        message: '^The EPF Number must be 8 digits long'
                    }
                };
            },
            epfRate: function(value, attrs) {
                if (!attrs.isEpf) {
                    return null;
                }

                return {
                    presence: {message: '^EPF Rate cannot be blank'},
                    numericality: {
                        greaterThanOrEqualTo: 0,
                        message: '^You need to specify a contribution rate'
                    }
                };
            },

            epfAdditionalRate: function(value, attrs) {
                if (!attrs.isEpf) {
                    return null;
                }

                return {
                    numericality: {
                        greaterThanOrEqualTo: 0,
                        message: '^The additional contribution rate must ' +
                            'be a positive number'
                    }
                };
            },

            epfEmployerRate: function(value, attrs) {
                if (!attrs.isEpf) {
                    return null;
                }

                return {
                    presence: {
                        message: '^EPF Rate cannot be blank'
                    },
                    inclusion: {
                        within: [
                            EmployeeConsts.EPF_EMPLOYER_RATE_GOVT_TABLE,
                            EmployeeConsts.EPF_EMPLOYER_RATE_5RM
                        ],
                        message: '^The employer EPF contribution rate is ' +
                            'not a valid value'
                    }
                };
            },

            epfEmployerAdditionalRate: function(value, attrs) {
                if (!attrs.isEpf) {
                    return null;
                }

                return {
                    numericality: {
                        greaterThanOrEqualTo: 0,
                        message: '^The additional contribution rate must be ' +
                            'a positive number'
                    }
                };
            }
        };

        this.model.isIntern = !!this.options.defaultPayrollDetails.models.find(d => d.getPayrollItem().id === 'cmyvIzZAyP');

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    resetPayrollConfirm: function() {

        if (
            !this.options.unsubmittedPayroll ||
            this.options.unsubmittedPayroll.isCreated()
        ) {
            return Promise.resolve();
        }

        return Promise.resolve(Alerts.show('infoConfirm', {
            title: 'Your saved payroll will be modified!',
            text: 'You have an unsubmitted payroll saved. ' +
                'If you continue, taxes calculated for this employee will ' +
                'be rendered invalid and will have to be recalculated.',
            confirmButtonText: 'Yes, Save Requirements'
        }));
    },

    _confirmMissingEPF: function() {
        const isICHolder =
            this.model.get('idType') === EmployeeConsts.ID_TYPE_IC_NUMBER;
        const missingEpf = isICHolder && !this.model.get('isEpf');
        if (missingEpf) {
            this.toggleError('epfNumber', 'An EPF Number should be entered');
            return Promise.resolve(Alerts.show('confirm', {
                text: 'Malaysians must contribute EPF. If the employee ' +
                    'is a first time contributor and does not have an EPF ' +
                    'number ' +
                    'yet, you may set the \'Contribute EPF\' field to Yes ' +
                    'and add 00000000 as a temporary EPF Number. You can ' +
                    'update to the new EPF number later. Existing EPF ' +
                    'numbers ' +
                    'can be enquired from KWSP at 03 - 8922 6000.',
                confirmButtonText: 'Yes, Save'
            }));
        }
    },

    _confirmMissingSOCSO: function() {
        const isICHolder =
            this.model.get('idType') === EmployeeConsts.ID_TYPE_IC_NUMBER;
        const missingSocso = isICHolder && !this.model.get('socsoCategory');
        if (missingSocso) {
            this.toggleError(
                'socsoCategory',
                'A SOCSO category should be chosen'
            );
            return Promise.resolve(Alerts.show('confirm', {
                html: `Effective 1 June 2016, the Employees' Social Security
Act, 1969 states that ALL employees who are under employment must contribute to
SOCSO.`,
                confirmButtonText: 'Yes, Save'
            }));
        }
    },

    save: function(ev) {
        return Promise.resolve().then(() => {
            return this._confirmMissingEPF();
        }).then(() => {
            return this._confirmMissingSOCSO();
        }).then(() => {
            // Actual save
            var $button = this.$(ev.currentTarget);
            var stopLoader;
            return this.resetPayrollConfirm().then(() => {
                stopLoader = loader.startFullScreen($button);
                this.model.setAdditionalConstraints(this.constraints);
                return this.model.save().catch(err => {
                    if (this.model.wasValid()) {
                        // the error is not a validation error
                        throw err;
                    }
                    throw new Error('validationError');
                });
            }).then(() => {
                if (this.options.unsubmittedPayroll) {
                    return this.options.unsubmittedPayroll
                        .resetEmployee({employee: this.model});
                }

                return true;
            }).then(() => {
                if (!this.options.isNew) {
                    this.render();
                    modal.showAlertSuccess(
                        'Statutory Requirements have been saved'
                    );

                    return Promise.resolve();
                }

                const goToPayslips = app.company.get('employeeCount') === 1 &&
                    this.options.isNew;
                if (goToPayslips) {
                    Alerts.show('success', {
                        text: 'Statutory requirements have been saved, ' +
                            'proceed to Previous Payslips now',
                        callback: () =>
                            app.mainRouter.navigate(
                                'employee/' + this.model.id +
                                    '/previousPayslips/isNew',
                                {trigger: true, replace: true}
                            )
                    });
                } else if (this.options.isNew) {
                    app.mainRouter.navigate(
                        'employee/' + this.model.id + '/previousPayslips/isNew',
                        {trigger: true, replace: true}
                    );
                }

                return null;
            }).catch(err => {
                if (
                    typeof err === 'object' &&
                    err.message !== 'validationError'
                ) {
                    Alerts.show('criticalError', err);
                }
            }).finally(() => {
                this.model.setAdditionalConstraints(null);
                if (typeof stopLoader === 'function') {
                    stopLoader();
                }
            });
        });
    },

    updateIsEpf: function(ev) {
        ev.preventDefault();
        const $employeeRateInput = this.$('[name="epfRate"]:checked');
        const employeeRate = this.getInputValue($employeeRateInput) || 0;
        const $employerRateInput = this.$('[name="epfEmployerRate"]:checked');
        const employerRate = this.getInputValue($employerRateInput) || 0;

        this.model.set({
            isEpf: this.$(ev.currentTarget).data('value'),
            epfRate: (
                this.$(ev.currentTarget).data('value') === false ?
                    0 : employeeRate
            ),
            epfEmployerRate: (
                this.$(ev.currentTarget).data('value') === false ?
                    0 : employerRate
            )
        });

        this.renderAttribute(this.model, 'epfRate');
        this.renderAttribute(this.model, 'epfEmployerRate');

        if (this.model.get('isEpf')) {
            this.$('[name="isEpfMemberBefore1998"]').iCheck('uncheck');
        }

        return this;
    },

    updateSsfwNumber: function(ev) {
        ev.preventDefault();

        this.model.set({
            socsoCategory:
                parseInt(this.$(ev.target).find('option:selected').val(), 10)
        });

        this.$('[name=ssfwNumber]').prop('disabled',
            this.model.get('socsoCategory') === 0);

        return this;
    },

    toggleIsEpfMemberBefore1998: function (ev) {
        var $toggle = this.$(ev.currentTarget);
        var isEpfMemberBefore1998 = $toggle.is(':checked');

        this.model.set({
            isEpfMemberBefore1998: isEpfMemberBefore1998,
            epfEmployerRate: isEpfMemberBefore1998 ?
                EmployeeConsts.EPF_EMPLOYER_RATE_GOVT_TABLE : EmployeeConsts.EPF_EMPLOYER_RATE_5RM
        });

        this.options.templateExtra.employerBaseRate = this.model.getEmployerEpfRate();

        this.options.templateExtra.baseRates = this.model.getApplicableEpfRates();

        this.render();
        return this;
    },

    render: function() {
        FormView.prototype.render.apply(this, arguments);

        this.model.setAdditionalConstraints(null);
        this.markMandatoryFields(this.constraints);
        this.markMandatoryFields({
            epfRate: {presence: true},
            epfEmployerRate: {presence: true}
        });
        this.$('[name=taxNumber]').inputmask('AA 99999999-999');
        this.$('[name=epfNumber]').inputmask('99999999');
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/StatutoryRequirements.js